import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["element"]
  static values = {
    threshold: { type: Number, default: 0.1 },
    rootMargin: { type: String, default: "0px 0px -100px 0px" },
    animationClass: { type: String, default: "is-visible" }
  }

  connect() {
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        threshold: this.thresholdValue,
        rootMargin: this.rootMarginValue
      }
    )

    // Observe all elements with animate-on-scroll class
    this.animateElements = document.querySelectorAll('.animate-on-scroll')
    this.animateElements.forEach(element => {
      this.observer.observe(element)
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(this.animationClassValue)
        // Optional: stop observing once animated
        // this.observer.unobserve(entry.target)
      }
    })
  }
}
